// Loader.js
import React, { useContext } from 'react';
import LoaderContext from './LoaderContext';
import './Loader.css'; // Same CSS from previous response

const Loader = () => {
    const { loading } = useContext(LoaderContext);

    if (!loading) return null;

    return (
        <div className="loader-overlay">
            <div className="loader" />
        </div>
    );
};

export default Loader;
